import { useEffect, useState } from "react";
import {
  AddAdminMutation,
  useAddAdminMutation,
} from "@/generated/graphql_billing";
import { ApolloError } from "@apollo/client";
import useRollbarUtil from "./useRollbarUtil";

type MutationResult = {
  loading: boolean;
  error?: ApolloError;
  data?: AddAdminMutation;
};

export const useCallBillingAddAdminMutation = (): [
  (userSub: string) => Promise<MutationResult>
] => {
  const { rollbar } = useRollbarUtil();
  const [addAdminMutation] = useAddAdminMutation({
    context: {
      api: "billing",
    },
  });

  const executeMutation = async (userSub: string): Promise<MutationResult> => {
    try {
      const { data, errors } = await addAdminMutation({
        variables: { input: { userSub } },
      });

      if (errors && errors.length > 0) {
        throw new Error(errors.map((e) => e.message).join("\n"));
      }

      return { loading: false, error: undefined, data };
    } catch (err) {
      rollbar.error("Failed to add admin", err);
      return { loading: false, error: err, data: undefined };
    }
  };

  return [executeMutation];
};
